﻿import jquery from 'jquery';
import HabEvents from '../Global/habitaclia-events';
import '../Common/Trackings/gtm-ecommerce';

class ListadoInmobiliarias {
    constructor() {
        jquery.publish(HabEvents.EventsEnum.LogosCargados);
        this.BoxDistric;
        this.PseudoSelect;
        this.__registerEvents();
    }

    __registerEvents() {
        this.BoxDistric = document.querySelector('.option-district');
        this.BoxDistric.addEventListener('click', this.__callBackSelect);
    }

    __callBackSelect() {
        this.PseudoSelect = document.querySelector('.pseudo-select');
        const isActive = this.PseudoSelect.classList.contains('open');

        if(isActive) {
            this.PseudoSelect.classList.remove('open');
        } else{
            this.PseudoSelect.classList.add('open');
        }
    }
}

new ListadoInmobiliarias();
